export default {
  en: {
    LOGIN_SECURITY_PAGE_TITLE: 'Login Security',
    LOGIN_SECURITY_REVOKE_ALL_TOKENS: 'Sign Out Of All Devices',
    LOGIN_SECURITY_LOGIN_UTC: 'Login date',
    LOGIN_SECURITY_LOGIN_IP: 'Ip',
    LOGIN_SECURITY_LOCATION: 'Location',
    LOGIN_SECURITY_USER_AGENT: 'Device',
    LOGIN_SECURITY_LOGIN_TYPE: 'Type',
    LOGIN_SECURITY_TRUSTED_DEVICE: '(trusted device)',
    LOGIN_SECURITY_TABLE_LOADING: 'Loading data',
    LOGIN_SECURITY_TABLE_EMPTY: 'No logins registered in the account yet',
    LOGIN_SECURITY_REVOKE_ALL_TOKENS_FAILURE: 'Unable to revoke all tokens',
    LOGIN_SECURITY_REVOKE_ALL_TOKENS_SUCCESS: 'Successfuly logged out from all devices',
  }
};